<ng-container *ngIf="vm$ | async as vm">
	<ng-container [ngSwitch]="toggle">
		<app-requisition-precedent-form
			*ngSwitchCase="RequisitionToggle.NEW"
			[searchTerm]="searchTerm"
			[(selectedRequisitionPrecedent)]="selectedRequisition"
			[teranetFields]="fields"
			(onSubmit)="onSubmit($event)"
			(formStatusChange)="onFormStatusChange($event)"
		>
			<div header-content class="flex flex-col">
				<h3>Add Requisition to File</h3>
				<p>Search and select from Closer’s list of requisition templates.</p>
			</div>
			<ng-container footer-content>
				<ui-button
					[matTooltip]="toolTipText_()"
					[disabled]="!!toolTipText_()"
					preset="MEDIUM_EMPHASIS"
					(click)="onToggleChange(RequisitionToggle.CUSTOM)"
					label="Create Template"
					[testHook]="testHooks.CreateTemplateButton"
				/>
				<ui-button
					preset="HIGH_EMPHASIS"
					type="submit"
					[loading]="vm.loading"
					[disabled]="isDisabled"
					label="Add Requisition"
					[testHook]="testHooks.AddRequisitionButton"
				/>
			</ng-container>
		</app-requisition-precedent-form>

		<app-new-custom-requisition-view
			*ngSwitchCase="RequisitionToggle.CUSTOM"
			secondaryButtonLabel="Back"
			[loading]="vm.loading"
			[isDisabled]="isDisabled"
			[selectedRequisitionId]="selectedRequisition?.id"
			(onSubmit)="onSubmit($event)"
			(onFormStatusChange)="onFormStatusChange($event)"
			(onSecondaryButtonClick)="onToggleChange(RequisitionToggle.NEW)"
		/>
	</ng-container>
</ng-container>
